import { getWcBrand } from '../../../src/worldcup/helpers/wcBrand.helper';

/** Max length guard for paste buffer / legacy codes. */
export const JOIN_WC_INVITE_CODE_MAX_LENGTH = 32;

/** Exact length of a standard invite code (alphanumeric, hyphens stripped). */
export const JOIN_WC_INVITE_CODE_LENGTH = 6;

/**
 * Auto-join first-login retry: a brand-new account (e.g. cross-app OAuth signup) can hit a
 * transient 5xx while `ensureUserExists` provisions the user row. Mirrors the durable
 * app-shell handler so the auto-join path is just as resilient. Manual entry doesn't retry.
 */
export const JOIN_WC_AUTO_JOIN_MAX_RETRIES = 1;
export const JOIN_WC_AUTO_JOIN_RETRY_DELAY_MS = 4000;

export const JOIN_WC_GROUP_COPY = {
  BACK: 'Back',
  ERROR_TITLE: 'Could not join',
  AUTO_JOIN_TITLE: 'Joining squad…',
  AUTO_JOIN_SUBTITLE: 'Locking in your spot — just a moment.',

  // OTP entry phase
  BADGE_LABEL: 'Invite code',
  ENTRY_TITLE: 'Got a code from\nyour host?',
  ENTRY_SUBTITLE: "Drop in the 6 characters and we'll show you the squad.",
  CODE_HELPER: '6 letters & numbers, like',
  CODE_PLACEHOLDER: 'OBR-7TK',
  VALIDATING: '✓ Looks good — pulling up the squad…',
  PREVIEW_ERROR: 'Invalid code — check with your host and try again.',
  // Preview (ticket) phase
  PREVIEW_JOIN_CTA: 'Join the squad',
  PREVIEW_DIFFERENT_CODE: 'Use a different code',
  PREVIEW_PRESENTED_BY: 'Presented by ',
  PREVIEW_TITLE_PREFIX: 'Join ',
  PREVIEW_MEMBER_COUNT_SUFFIX_ONE: 'member already in',
  PREVIEW_MEMBER_COUNT_SUFFIX_MANY: 'members already in',
} as const;

/**
 * Subtitle when the squad carries no description. Named after the competition the squad plays,
 * not the World Cup: the join screen is shared by every competition (specs/champions-league
 * Story 20). Falls back to the WC brand when the server predates the field.
 */
export const getPreviewSquadSubtitleFallback = (competitionName?: string | null): string =>
  `A ${competitionName?.trim() || getWcBrand().NAME} prediction squad.`;
